module.exports = __webpack_public_path__ + "static/media/2.8_preview.c736d2e3.png";